import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import PlantFormModal from "./PlantFormModal";
import config from "../../config";
import { toast } from "react-toastify";
import Layout from "../../components/layouts/Main";
import { FaArrowRight } from "react-icons/fa";

const PlantList = () => {
    const [plants, setPlants] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const fetchPlants = async () => {
        const res = await axios.get(`${config.API_BASE_URL}/plants`);
        setPlants(res.data);
    };

    useEffect(() => {
        fetchPlants();
    }, []);

    const handleSave = async (data) => {
        try {
            await axios.post(`${config.API_BASE_URL}/plants`, data);
            toast.success("Plant added.");
            fetchPlants();
            setShowModal(false);
        } catch (err) {
            toast.error("Failed to add plant.");
        }
    };

    return (
        <Layout>
            {/* Breadcrumb */}
            <nav aria-label="breadcrumb" className="mb-3">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                    <li className="breadcrumb-item active">Plants</li>
                </ol>
            </nav>

            {/* Bill Of Materials (BOM) Header */}
            <Row className="gy-3">
                <Col className="col"><h2>Plants</h2></Col>
                <Col className="text-end col-auto">
                    <div className="d-flex justify-content-end flex-wrap gap-2">
                        <Button onClick={() => setShowModal(true)}>+ Add Plant</Button>
                    </div>
                </Col>
            </Row>

            <Container fluid className="my-4">

                <Row xs={1} sm={2} md={3} xl={4} className="g-3">
                    {plants.map(plant => (
                        <Col key={plant._id}>
                            <Card className="h-100 shadow-sm">
                                <Card.Body>
                                    <Card.Title className="d-flex justify-content-between align-items-center mb-0">
                                        <span>{plant.name}</span>
                                        <Link to={`/plants/${plant._id}`} className="text-primary">
                                            <FaArrowRight />
                                        </Link>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <PlantFormModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    onSave={handleSave}
                />
            </Container>
        </Layout>
    );
};

export default PlantList;
